/* eslint-disable no-useless-concat */
import React, { useState } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";

import {
  FormControlLabel,
  Paper,
  Switch,
  Stack,
} from "@mui/material";

import { ACTIVITY, SAVE_ACTIVITY } from "./Graphql";
import ControlMUItextField from "../HOC/MUI/ControlMUItextField";
import { useForm } from "react-hook-form";
import FormButton from "../CustomComponents/Buttons/FormButton";
import ButtonLoading from "../HOC/FunctionComponents/LoadingPages/ButtonLoading";

import FullScreenLoading from "../HOC/FunctionComponents/LoadingPages/FullScreenLoading";
import { setValidationError } from "../HOC/CustomFunctions/setValidationError";
import { pushUrl } from "../HOC/CustomFunctions/pushUrl";

import Grid from "@mui/material/Unstable_Grid2";
import TitleAppBar from "../../Layout/TitleAppBar";
import NotFound from "../../Error/NotFound";

import { StyledLoading, classesLoad } from "../../GlobalStyles/LoadingStyle";
import { RootStyleForm, classesForm } from "../../GlobalStyles/FormStyle";

const ActivityForm = (props) => {
  const [active, setActive] = useState({
    activity: true,
  });
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    setError,
  } = useForm();


  const activityId = parseInt(props.match.params.id);

  const { loading, data } = useQuery(
    gql`
      ${ACTIVITY.query}
    `,
    {
      skip: !activityId,
      fetchPolicy: "network-only",
      variables: { id: parseInt(activityId) },
      onCompleted: (data) => {

        setValue("code", data?.activity?.code);
        setValue("name", data?.activity?.name);
        setActive((prev) => ({
          ...prev,
          activity: data?.activity?.active,
        }));
      },
    }
  );


  const [saveActivity, { loading: saveActivityLoading }] = useMutation(
    gql`
      ${SAVE_ACTIVITY.query}
    `
  );



  const onSubmit = (data) => {
    for (const key in data) {
      if (data[key] === "" || data[key] === null) {
        delete data[key];
      }
    }
    saveActivity({
      variables: {
        input: {
          ...(activityId && { id: activityId }),
          active: active.activity,
          ...data,
        },
      },
    })
      .then((data) => {
        pushUrl(props, `/admin/activity/${data?.data?.saveActivity?.id}`);
      })
      .catch(({ graphQLErrors }) => {

        setValidationError(graphQLErrors, setError);
        console.log(graphQLErrors);
      });
  };
  const handelActivate = (e) => {
    const active = e.target.checked;
    setActive((prev) => ({
      ...prev,
      activity: active,
    }));
  };

  return loading ? (
    <StyledLoading
      container
      item
      justifyContent="center"
      className={classesLoad.main}
    >
      <FullScreenLoading height={"100%"} />
    </StyledLoading>
  ) : !data?.activity && activityId ? (
    <NotFound />
  ) : (
    <RootStyleForm>
      <TitleAppBar path={props.match.path} />
      <Stack spacing={2} p={2}>
        <Paper className={classesForm.box}>
          <Grid
            container
            spacing={2}
            component="form"
            onSubmit={handleSubmit(onSubmit)
            }
          >
            <Grid
              container
              justifyContent="space-between"
              sm={12}
              alignItems={"center"}
            >
              <Grid xs={6}>

              </Grid>
              <Grid xs={6} textAlign={"end"}>
                <FormControlLabel
                  checked={active.activity}
                  control={<Switch color="primary" />}
                  label={t("active")}
                  labelPlacement="start"
                  onChange={handelActivate}

                />
              </Grid>
            </Grid>

            <Grid xs={12} sm={6}>
              <ControlMUItextField
                control={control}
                errors={errors}
                name={"code"}
                label={t("code")}
              />
            </Grid>
            <Grid xs={12} sm={6}>
              <ControlMUItextField
                control={control}
                errors={errors}
                name={"name"}
                label={t("name")}
                rules={{ required: t("fieldIsRequired") }}
              />
            </Grid>

            <Grid container sm={12} justifyContent="flex-end" m={0}>

              <FormButton disabled={saveActivityLoading}>
                {saveActivityLoading ? <ButtonLoading /> : t("save")}
              </FormButton>

            </Grid>
          </Grid>
        </Paper>
      </Stack>


    </RootStyleForm>
  );
};

export default ActivityForm;

